import { createSvgIcon } from '@mui/material';
import Styled from "./custom-styled-icon";

export const Link = Styled(
  createSvgIcon(
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.70656 7.29297C10.2066 8.79297 10.2066 11.2196 8.70656 12.713C7.20656 14.2063 4.7799 14.213 3.28656 12.713C1.79323 11.213 1.78656 8.7863 3.28656 7.29297"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.05989 8.93992C5.49989 7.37992 5.49989 4.84659 7.05989 3.27992C8.61989 1.71326 11.1532 1.71992 12.7199 3.27992C14.2866 4.83992 14.2799 7.37326 12.7199 8.93992"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>,
    "Link",
  ),
);

export default Link;
